import { render } from "./DataCardLoader.vue?vue&type=template&id=fbd3481c&scoped=true"
import script from "./DataCardLoader.vue?vue&type=script&lang=js"
export * from "./DataCardLoader.vue?vue&type=script&lang=js"

import "./DataCardLoader.vue?vue&type=style&index=0&id=fbd3481c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd3481c"]])

export default __exports__